import { shaderMaterial } from "@react-three/drei";
import fragmentShader from "../shader/magnetic_frag.glsl";
import vertexShader from "../shader/magnetic_vert.glsl";

import { extend, useFrame } from "@react-three/fiber";
import { Color, Vector3 } from "three";
import { patchShaders } from "gl-noise";
import { useRef, forwardRef, useImperativeHandle } from "react";
import { mergeRefs } from "react-merge-refs";

const vert = patchShaders(vertexShader);
const frag = patchShaders(fragmentShader);

export const MagneticFieldMaterialImpl = shaderMaterial(
  {
    uBaseColor: new Color("#ff0000"),
    uFresnelColor: new Color("#0000ff"),
    uFresnelPower: 1,
    opacity: 1,
    uTime: 0,
    uCarrierPosition: new Vector3(),
  },
  vert,
  frag,
);

extend({ MagneticFieldMaterialImpl });

const MagneticFieldMaterial = forwardRef(
  ({ uBaseColor = new Color("#ff0000"), uFresnelColor = new Color("#0000ff"), uFresnelPower = 1, ...props }, ref) => {
    const localref = useRef();

    useFrame(({ clock }) => {
      if (localref.current) {
        localref.current.uniforms.uTime.value = clock.elapsedTime;
      }
    }, []);

    useImperativeHandle(ref, () => ({
      setCarrierPosition: (v) => {
        if (localref.current) {
          localref.current.uniforms.uCarrierPosition.value.copy(v);
        }
      },
    }));

    return (
      <magneticFieldMaterialImpl
        {...props}
        attach="material"
        uBaseColor={uBaseColor}
        uFresnelColor={uFresnelColor}
        uFresnelPower={uFresnelPower}
        ref={mergeRefs([localref, ref])}
        key={MagneticFieldMaterialImpl.key}
      />
    );
  },
);

export default MagneticFieldMaterial;
